module.exports = __webpack_public_path__ + "qa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/qa.svg
// module id = 1030
// module chunks = 0